module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "philosophy"
    }
  }, [_c('h2', [_vm._v("Un enfoque global de la salud basado en la prevención")]), _vm._v(" "), _c('div', {
    staticClass: "philosophy"
  }, [_c('h3', [_vm._v("Nutrición")]), _vm._v(" "), _c('h3', [_vm._v("Comportamiento")]), _vm._v(" "), _c('h3', [_vm._v("Homeopatía")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9b2266e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Es/Philosophy.vue
// module id = 149
// module chunks = 0